import axiosIns from "@/api/axios";

export const GET_SUBORDINATES_LEARNING = (params) => {
  return axiosIns.get("/tna/subordinates", { params });
};

export const GET_FILTER_USERS = (payload) => {
  return axiosIns.post("/users/employee-filters", payload);
};
